var _effectorFileName = "/builds/gmini/ui-common/src/Popup/Popup.tsx";
import React from 'react';
import { Portal } from './Portal';
import { Backdrop, Container, ContentWrapper } from './Popup.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Popup = function Popup(_ref) {
  var onClose = _ref.onClose,
      open = _ref.open,
      children = _ref.children,
      width = _ref.width,
      minHeight = _ref.minHeight,
      maxWidth = _ref.maxWidth,
      id = _ref.id;

  if (!open) {
    return null;
  }

  return /*#__PURE__*/_jsx(Portal, {
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Backdrop, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(ContentWrapper, {
        width: width,
        minHeight: minHeight,
        maxWidth: maxWidth,
        id: id,
        children: children
      })]
    })
  });
};